<script setup>
import { useCustomFieldRenderer } from '@/composables/useCustomFieldRenderer'
import CustomFieldDefaultType from '@/components/customFields/CustomFieldDefaultType.vue'
const props = defineProps({
    project: {
        type: Object,
        required: true
    },
    unit: {
        type: Object,
        required: true
    },
    fieldKey: {
        type: String,
        required: true
    }
})

const customFieldRenderer = useCustomFieldRenderer(props.project, props.unit, props.fieldKey)

const {
    field,
    raw,
    typed,
    full,
    prefix,
    suffix,
    customRenderer,
    hideRenderer,
    hasPrefix,
    hasSuffix,
    hasCustomRenderer,
    hasHideRenderer,
    isHidden
} = customFieldRenderer
</script>
<template>
    <custom-field-default-type :project="project" :unit="unit" :field-key="fieldKey">
        <template #hide="scope">
            <slot name="hide" v-bind="scope" />
        </template>
        <template #hidden="scope">
            <slot name="hidden" v-bind="scope" />
        </template>
        <template #prefix="scope">
            <slot name="prefix" v-bind="scope" />
        </template>
        <template #suffix="scope">
            <slot name="suffix" v-bind="scope" />
        </template>
        <template #default="scope">
            <slot v-bind="scope">
                <div v-html="scope.typed" />
            </slot>
        </template>
    </custom-field-default-type>
</template>
